export const MAX_INVOICE_BYTES = 16 * 1024 * 1024;
export const MAX_INVOICE_PHOTOS = 10;

export function invoiceUploadError(files, imagesOnly = false) {
    if (!files.length) return 'Selecciona un PDF o fotos de la factura';
    if (files.length > MAX_INVOICE_PHOTOS) return 'Puedes añadir hasta 10 fotos de la misma factura';
    const allowed = imagesOnly || files.length > 1 ? /\.(jpe?g|png)$/i : /\.(pdf|jpe?g|png)$/i;
    if (files.some(file => !allowed.test(file.name))) return imagesOnly || files.length > 1
        ? 'Selecciona fotos JPG, JPEG o PNG de la misma factura; sube los PDF por separado'
        : 'Selecciona un PDF, JPG, JPEG o PNG';
    if (files.some(file => !file.size)) return 'Hay un archivo vacío en la selección';
    if (files.reduce((sum, file) => sum + file.size, 0) > MAX_INVOICE_BYTES) return files.length > 1
        ? 'Las fotos superan los 16 MB en conjunto' : 'El archivo supera los 16 MB';
    return '';
}
